<script setup lang="ts" name="DisplayMetricStandardLayout"></script>

<template>
  <div
    class="grid grid-cols-1 gap-2 md:grid-cols-2 2xl:grid-cols-3 4xl:grid-cols-4"
  >
    <slot />
  </div>
</template>
